function handleBreadcrumbsMobile() {
  if ($(window).width() < 678) {
    let breadcrumbItem = $(".breadcrumb-item");

    for (let i = 0; i < breadcrumbItem.length - 2; i++) {
      let a = i;
      breadcrumbItem.eq(a).removeClass("parent");
      breadcrumbItem.eq(i).hide();
      breadcrumbItem.eq(++a).addClass("parent");
    }
    $(".breadcrumb-item.active").hide();
    $(".breadcrumb-item.parent .breadSlash").hide();
    $(".breadcrumb-item.parent").prepend("<span class='breadSlash'><</span>");

    if (breadcrumbItem.length <= 2) {
      $(".breadcrumb-item .breadSlash").eq(0).hide();
      breadcrumbItem.eq(0).prepend("<span class='breadSlash'><</span>");
    }
    $(".breadcrumb").show();
  }
}

export default handleBreadcrumbsMobile;
